export default __webpack_public_path__ + "static/1password-2d521f8498b39274c7ccf1fde2590e8b.png";